const mark = action => `user/${action}`;

export const FETCH_ONE = mark("FETCH_ONE");
export const FETCH_ONE_SUCCESS = mark("FETCH_ONE_SUCCESS");
export const FETCH_ONE_FAILED = mark("FETCH_ONE_FAILED");
export const fetchOne = token => ({ type: FETCH_ONE, payload: { token } });
export const fetchOneSuccess = data => ({
  type: FETCH_ONE_SUCCESS,
  payload: { data }
});

export const fetchOneFailed = error => ({
  type: FETCH_ONE_FAILED,
  payload: { error }
});

export const FETCH_ALL = mark("FETCH_ALL");
export const FETCH_ALL_SUCCESS = mark("FETCH_ALL_SUCCESS");
export const FETCH_ALL_FAILED = mark("FETCH_ALL_FAILED");
export const fetchAll = token => ({ type: FETCH_ALL, payload: { token } });
export const fetchAllSuccess = data => ({
  type: FETCH_ALL_SUCCESS,
  payload: { data }
});

export const fetchAllFailed = error => ({
  type: FETCH_ALL_FAILED,
  payload: { error }
});

export const CREATE_ONE = mark("CREATE_ONE");
export const CREATE_ONE_SUCCESS = mark("CREATE_ONE_SUCCESS");
export const CREATE_ONE_FAILED = mark("CREATE_ONE_FAILED");
export const createOne = data => ({
  type: CREATE_ONE,
  payload: { data },
  meta: { thunk: true }
});
export const createOneSuccess = (data, meta) => ({
  type: CREATE_ONE_SUCCESS,
  payload: { data },
  meta
});

export const createOneFailed = (error, meta) => ({
  type: CREATE_ONE_FAILED,
  payload: { error },
  meta,
  error: true
});

export const DELETE_ONE = mark("DELETE_ONE");
export const DELETE_ONE_SUCCESS = mark("DELETE_ONE_SUCCESS");
export const DELETE_ONE_FAILED = mark("DELETE_ONE_FAILED");
export const deleteOne = id => ({
  type: DELETE_ONE,
  payload: { id },
  meta: { thunk: true }
});
export const deleteOneSuccess = (id, meta) => ({
  type: DELETE_ONE_SUCCESS,
  payload: { id },
  meta
});

export const deleteOneFailed = (error, meta) => ({
  type: DELETE_ONE_FAILED,
  payload: { error },
  meta,
  error: true
});

export const UPDATE_ONE = mark("UPDATE_ONE");
export const UPDATE_ONE_SUCCESS = mark("UPDATE_ONE_SUCCESS");
export const UPDATE_ONE_FAILED = mark("UPDATE_ONE_FAILED");
export const updateOne = (id, data) => ({
  type: UPDATE_ONE,
  payload: { id, data },
  meta: { thunk: true }
});
export const updateOneSuccess = (data, meta) => ({
  type: UPDATE_ONE_SUCCESS,
  payload: { data },
  meta
});

export const updateOneFailed = (error, meta) => ({
  type: UPDATE_ONE_FAILED,
  payload: { error },
  meta,
  error: true
});



// WEBPACK FOOTER //
// ./src/actions/user.js